import { getListDataFunctionFactory } from '../../../modules/getListDataFunctionFactory'
import { getIndustryListData, _getIDataById } from '../industries/mockData'
import type { ISubindustry } from '~/types/industry/models'
import type { TEntityId } from '~/types/models'

const subindustryListData = undefined as unknown as ISubindustry[]

export const getSubindustryListData = getListDataFunctionFactory<
  ISubindustry[]
>({
  listData: subindustryListData,
  storageKey: 'subindustries',
  getStartingListData: getStartingSubindustryListData,
})

export async function getSubindustryListDataByIndustryId(
  id: TEntityId
): Promise<ISubindustry[]> {
  const list: ISubindustry[] = await getSubindustryListData()
  if (!list) {
    throw new Error(`getSubindustryListData returned undefined/null`)
  }
  const subindustryListData =
    list.filter((subindustry) => subindustry.industry.id === id) ?? []
  return subindustryListData
}

export function _getSIDataById(
  id: TEntityId,
  list: ISubindustry[]
): ISubindustry {
  if (!list) {
    throw new Error(`_getSIDataById called with undefined/null list`)
  }
  const industry = list.find((p: ISubindustry) => p.id === id)
  if (!industry) {
    throw new Error(`Can't find subindustry '${id}'`)
  }
  return industry
}

export async function getSubindustryDataById(
  id: TEntityId
): Promise<ISubindustry> {
  const list: ISubindustry[] = await getSubindustryListData()
  if (!list) {
    throw new Error(`getSubindustryListData returned undefined/null`)
  }
  return _getSIDataById(id, list)
}

export async function getStartingSubindustryListData(): Promise<
  ISubindustry[]
> {
  const list = await getIndustryListData()
  return [
    {
      id: 'XXSI0001',
      hrid: 'SI0001',
      industry: _getIDataById('XXI0001', list),
      descr: 'Banking',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXSI0002',
      hrid: 'SI0002',
      industry: _getIDataById('XXI0002', list),
      descr: 'Hosptial',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXSI0003',
      hrid: 'SI0003',
      industry: _getIDataById('XXI0003', list),
      descr: 'General Liability',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXSI0004',
      hrid: 'SI0004',
      industry: _getIDataById('XXI0004', list),
      descr: 'Law Firm',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXSI0005',
      hrid: 'SI0005',
      industry: _getIDataById('XXI0005', list),
      descr: 'Automotive',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXSI0006',
      hrid: 'SI0006',
      industry: _getIDataById('XXI0006', list),
      descr: 'Fine Dining',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXSI0007',
      hrid: 'SI0007',
      industry: _getIDataById('XXI0007', list),
      descr: 'Pest Control',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXSI0008',
      hrid: 'SI0008',
      industry: _getIDataById('XXI0008', list),
      descr: 'Data Center',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXSI0009',
      hrid: 'SI0009',
      industry: _getIDataById('XXI0005', list),
      descr: 'Watches',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXSI0010',
      hrid: 'SI0010',
      industry: _getIDataById('XXI0005', list),
      descr: 'Dairy Products',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXSI0011',
      hrid: 'SI0011',
      industry: _getIDataById('XXI0007', list),
      descr: 'Travel Info',
      version: '1',
      canBeDeleted: false,
    },
  ]
}
